// extracted by mini-css-extract-plugin
export default {"title":"FiltersViewButton_title__le0B2","box":"FiltersViewButton_box__m+DMr","button":"FiltersViewButton_button__fB6C3"};